module.exports = __webpack_public_path__ + "img/hero-06.b5c3c47f.jpg";